<template>
  <div @click="openImg">
    <el-upload
      :key="uploadInstanceKey"
      class="pic-uploader-component"
      :disabled="disabled || ossLoading"
      :headers="uploadHeaders"
      :action="fileBaseUrl"
      :show-file-list="false"
      :data="uploadFormData"
      :before-upload="beforeUpload"
      :on-success="handleUploadSuccess"
    >
      <div v-if="value" class="viewImg">
        <div class="btn">
          <i class="el-icon-refresh deleteBtn"></i>
          <i
            class="el-icon-download deleteBtn"
            @click.stop="downloadImg()"
          ></i>
        </div>
        <img :src="imageDisplaySrc" class="pic" />
      </div>

      <div v-else class="upBlock">
        <i class="el-icon-plus pic-uploader-icon"></i>
      </div>
    </el-upload>
    <el-dialog :visible.sync="visible" :append-to-body="visible">
      <img width="100%" :src="imageDisplaySrc" alt />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileBaseUrl: "",
      baseUrl: "",
      lang: localStorage.getItem("lang") || "zh_CN",
      visible: false,
      ossData: null,
      temp: "",
      ossLoading: false,
      uploadEpoch: 0,
    };
  },
  props: {
    value: {
      default: "",
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    uploadInstanceKey() {
      return `upimg-${this.value || "empty"}-${this.uploadEpoch}`;
    },
    imageDisplaySrc() {
      if (!this.value) {
        return "";
      }
      if (/^https?:\/\//i.test(this.value)) {
        return this.value;
      }
      const base = (this.fileBaseUrl || "").replace(/\/$/, "");
      const path = String(this.value).replace(/^\//, "");
      return base ? `${base}/${path}` : path;
    },
    uploadHeaders() {
      if (!this.ossData || !this.ossData.security_token) {
        return {};
      }
      return {
        "x-oss-security-token": this.ossData.security_token,
      };
    },
    uploadFormData() {
      return this.ossData && typeof this.ossData === "object"
        ? { ...this.ossData }
        : {};
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.uploadEpoch += 1;
      }
      this.getOss();
    },
  },
  mounted() {
    this.getOss();
  },
  methods: {
    downloadImg() {
      const url = this.imageDisplaySrc;
      if (url) {
        window.open(url);
      }
    },
    beforeUpload() {
      this.ossLoading = true;
      return this.getOss()
        .catch(() => {
          this.$message.error("获取上传凭证失败，请稍后重试");
          return Promise.reject(new Error("getOss failed"));
        })
        .finally(() => {
          this.ossLoading = false;
        });
    },
    handleUploadSuccess() {
      const data = this.ossData && this.ossData.key;
      if (data) {
        this.$emit("input", data);
      }
      this.uploadEpoch += 1;
      this.getOss();
    },
    openImg() {
      if (this.disabled) {
        this.visible = true;
      }
    },
    getOss() {
      const date = new Date();
      this.temp = date.getTime();
      return this.$request
        .getOss({
          fileName: this.temp,
        })
        .then((res) => {
          this.fileBaseUrl = res.data.uploadUrl;
          this.ossData = res.data.formData;
        });
    },
  },
};
</script>
  
  <style scoped>
.pic-uploader-component .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.pic-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.pic {
  width: 178px;
  height: 178px;
  display: block;
}
.pic-uploader-component .el-upload:hover {
  border-color: #409eff;
}
.upBlock {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
.viewImg {
  position: relative;
}
.btn {
  position: absolute;
  left: 0;
  right: 0px;
  bottom: 0;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  transition: 0.5s;
}

.btn:hover {
  background-color: rgba(0, 0, 0, 0.685);
}
.deleteBtn {
  font-size: 36px;
  color: #8c939da6;
  transition: 0.5s;
}

.deleteBtn:hover {
  color: #409eff;
  transform: scale(2);
}
</style>
  


// WEBPACK FOOTER //
// src/components/upImg.vue